import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import { supabase } from '../supabase'; // Import Supabase

function Login() {
    const { setUserRole, setIsAuthenticated } = useContext(AuthContext);
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const navigate = useNavigate();
    const [message, setMessage] = useState(''); // ✅ Add this line to fix the error
    const [error, setError] = useState('');

    {message && <p style={{ color: "green", fontWeight: "bold" }}>{message}</p>}


    const handleLogin = async (e) => {
        e.preventDefault();
        setError(""); // ✅ Clear previous errors
    
        const { data, error } = await supabase.auth.signInWithPassword({ email, password });
    
        if (error) {
            setError('Invalid email or password.');
            return;
        }
    
        const user = data.user;
    
        if (user) {
            // 🔹 Fetch user role & approval status
            const { data: userData, error: userError } = await supabase
                .from('users')
                .select('id, role, approved')
                .eq('id', user.id) // ✅ Fetch only the logged-in user's data
                .single();
    
            console.log("📌 Debug - User Data from Supabase:", userData);
    
            if (userError || !userData) {
                console.error("❌ Debug - Supabase Error:", userError?.message || "No user found");
                setError('Access denied. Contact admin.');
                return;
            }
    
            if (userData.role !== 'admin' && !userData.approved) {
                console.log("❌ Debug - User Not Approved:", userData);
                setError('Your account is pending approval. Contact admin.');
                return;
            }
    
            setUserRole(userData.role);
            localStorage.setItem('userRole', userData.role);
            setIsAuthenticated(true);
            navigate('/');
        }
    };
    
    
    
    
    const handleGoogleSignup = async () => {
        const { data, error } = await supabase.auth.signInWithOAuth({
            provider: 'google'
        });

        if (error) {
            console.error("Error signing in with Google: ", error);
            setError("Error signing in with Google. Please try again.");
        }
    };

    const handleForgotPassword = async () => {
        if (!email) {
          setError("Please enter your email first.");
          return;
        }
      
        setError("");  // ✅ Clear previous errors
        setMessage(""); // ✅ Clear previous success messages
      
        const { error } = await supabase.auth.resetPasswordForEmail(email, {
          redirectTo: "http://quotationer.netlify.app/reset-password", // ✅ Ensure this matches your frontend URL
        });
      
        if (error) {
          setError(`Error sending password reset email: ${error.message}`);
        } else {
          console.log("✅ Password reset link sent! Check your email.");
        }
      };
      
      
      
    

    return (
        <div className="auth-form">
            <h1>Login</h1>
            {message && <p style={{ color: "green", fontWeight: "bold", marginTop: "10px" }}>{message}</p>}
                {error && <p style={{ color: "red", fontWeight: "bold", marginTop: "10px" }} className="error">{error}</p>}

            <form onSubmit={handleLogin}>
                <input
                    type="email"
                    placeholder="Enter your email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                />
                <input
                    type="password"
                    placeholder="Enter your password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                />
        <button type="submit" style={{ marginBottom: '8px' }}>Login</button>            </form>

            {/* Google Sign-in */}
            {/* <button 
                onClick={handleGoogleSignup} 
                style={{ color: 'white', backgroundColor: 'black', border: '1px solid black', padding: '10px', cursor: 'pointer' }}
            >
                Continue with Google
            </button> */}
            <p>
                Don't have an account? <a href="/help">contact admin</a>.
            </p>
            
            {/* <p>
                Don't have an account? <a href="/signup">Sign up here</a>.
            </p> */}

            <p>
                Forgot your password?{' '}
                <span onClick={handleForgotPassword} style={{ color: 'blue', cursor: 'pointer' }}>
                Reset it here.
                </span>
            </p>
        </div>
    );
}

export default Login;
